module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori@3x-038d58498c04570f08ac18a040ac65d2.webp";